import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_SUCCESS = 'LOAD_TV_SUCCESS';
export const LOAD_FAIL = 'LOAD_TV_FAIL';
export const LOAD_REQUEST = 'LOAD_TV_REQUEST';
export const LOAD_OPTIONS_SUCCESS = 'LOAD_TV_OPTIONS_SUCCESS';

export const UPDATE_SUCCESS = 'UPDATE_TV_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_TV__FAIL';
export const UPDATE_REQUEST = 'UPDATE_TV_REQUEST';

const loadTvRequest = () => ({ type: LOAD_REQUEST });
const loadTvFail = (error) => ({ type: LOAD_FAIL, error });
const loadTvSuccess = (tv) => ({ type: LOAD_SUCCESS, tv });
const loadTvOptionsSuccess = (options) => ({ type: LOAD_OPTIONS_SUCCESS, options });

const updateTvRequest = (tv) => ({ type: UPDATE_REQUEST, tv });
const updateTvSuccess = (result) => ({ type: UPDATE_SUCCESS, result });
const updateTvFail = (error) => ({ type: UPDATE_FAIL, error });

function reformatTvForOptionsMenu(data) {
  return data.map((tv) => ({
    value: tv.DeviceId.toString(),
    label: tv.Configuration.Name
  }));
}

function updateReformat(configurationData, tvId) {
  return {
    Configuration: configurationData,
    DeviceId: parseInt(tvId, 10)
  };
}

export const loadTv = () => (dispatch) => {
  /* Loads TV-s and all related graphs */
  dispatch(loadTvRequest());
  return communicate({
    url: 'Graphs',
    method: 'get'
  })
    .then((response) => {
      dispatch(loadTvSuccess(response.data.Data));
      dispatch(loadTvOptionsSuccess(reformatTvForOptionsMenu(response.data.Data)));
    }).catch((err) => {
      dispatch(loadTvFail(err));
      toastrError(err);
    });
};

export const updateTv = (tvId, data) => (dispatch) => {
  dispatch(updateTvRequest(tvId));
  return communicate({
    url: 'Graphs',
    method: 'put',
    data,
    getParams: `?deviceId=${tvId}`
  })
    .then((response) => {
      dispatch(updateTvSuccess(updateReformat(response.data.Data, tvId)));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(updateTvFail(err));
      toastrError(err);
    });
};
